<template>
  <button @click="open" class="btn btn-sm btn-success mr-1 mb-1">
    <font-awesome-icon icon="address-book"/>&nbsp;{{ $t('buyUser') }}
    <b-modal v-model="showForm" :title="$t('buyUser')" no-close-on-backdrop no-enforce-focus size="xl">
      <div class="modal-content">
        <div class="modal-body">
          <form>
            <div class="row">
              <div class="col-md">
                <client-select :label="$t('client')" :model="formModel" attribute="client"
                               :errors="formErrors"></client-select>
                <div v-if="getClientLoading" class="text-center">
                  <b-spinner></b-spinner>
                </div>
                <div v-else-if="client">
                  <p>
                    <span>{{ $t('sales') }}</span>:
                    <b>{{ client.populatedSales ? client.populatedSales.name : $t('noSales') }}</b>
                  </p>
                  <p>
                    <span>{{ $t('currentPlan') }}</span>:
                    <b v-if="getCurrentPlanLoading">
                      <b-spinner small></b-spinner>
                    </b>
                    <b v-else-if="currentPlanName">{{ currentPlanName }}</b>
                    <b v-else>{{ $t('noCurrentPlanFound') }}</b>
                  </p>
                  <p>
                    <span>{{ $t('userPrice') }}</span>:
                    <b v-if="getCurrentPlanLoading">
                      <b-spinner small></b-spinner>
                    </b>
                    <b v-else-if="currentPlanUserPrice">{{ currentPlanUserPrice | numFormat }}</b>
                    <b v-else>{{ $t('noCurrentPlanFound') }}</b>
                  </p>
                  <p><span>{{ $t('currentUserLimit') }}</span>: <b>{{ client.userLimit }}</b></p>
                  <p><span>{{ $t('expireTime') }}</span>: <b>{{ client.expireTime | moment('DD/MM/YYYY') }}</b></p>
                  <p><span>{{ $t('creditBalance') }}</span>: <b>{{ client.creditBalance | numFormat }}</b></p>
                  <p><span>{{ $t('creditLimit') }}</span>: <b>{{ client.creditLimit | numFormat }}</b></p>
                </div>
              </div>
              <div class="col-md">
                <form-input :label="$t('numberOfUserToBuy')" attribute="numberOfUserToBuy" :model="formModel"
                            :errors="formErrors"></form-input>
                <form-input :label="$t('numberOfUserGifted')" attribute="numberOfUserGifted" :model="formModel"
                            :errors="formErrors"></form-input>
                <form-input :label="$t('discount')" attribute="discountAmount" :model="formModel"
                            :errors="formErrors"></form-input>
                <form-input :label="$t('note')" attribute="note" :model="formModel" :errors="formErrors"></form-input>
                <p><span>{{ $t('monthCount') }}: </span>
                  {{ monthCount | numFormat('0.00') }}
                </p>
                <p><span>{{ $t('total') }}: </span>
                  {{
                    formModel.numberOfUserToBuy * monthCount * currentPlanUserPrice - formModel.discountAmount | numFormat
                  }}
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button
            :disabled="!formModel.client || !formModel.numberOfUserToBuy || !monthCount || monthCount < 0 || !['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)"
            class="btn btn-primary float-right" @click="purchase()">
          {{ $t('savePlanOrder') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
import CRUD from "@/mixins/CRUD";
import ClientSelect from "../../../components/ClientSelect";
import moment from "moment-timezone";

export default {
  components: {ClientSelect},
  props: ['clientId'],
  mixins: [CRUD],
  data: function () {
    return {
      defaultFormModel: {
        client: this.clientId ? this.clientId : null,
        numberOfUserToBuy: 0,
        numberOfUserGifted: 0,
        monthCount: 0,
        discountAmount: 0,
        note: null
      },
      client: null,
      currentPlanName: null,
      currentPlanUserPrice: 0,
      getClientLoading: false,
      getCurrentPlanLoading: false,
      monthCount: 0,
    }
  },
  computed: {},
  methods: {
    open: function () {
      this.showForm = true;
      this.formModel = {};
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
      this.getClient();
    },
    purchase() {
      let loader = this.$loading.show();
      this.$service({url: '/plan-order/buy-user/', method: 'post', data: this.formModel}).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
          this.$bus.$emit('planOrder');
          this.$bus.$emit('loadClient');
          this.showForm = false;
        } else {
          this.$swal({
            title: this.$t('error'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    getClient() {
      if (this.formModel.client) {
        this.$service.get('/client/' + this.formModel.client).then(response => {
          if (response) {
            this.client = response.data;
          }
          let timezone = this.client && this.client.timezone ? this.client.timezone : 'Asia/Ho_Chi_Minh';
          this.monthCount = 0;
          if (this.formModel.client && this.client) {
            this.monthCount = Number(Math.round(moment(this.client.expireTime).tz(timezone).diff(moment().tz(timezone).startOf('day'), 'month', true) + 'e1') + 'e-1')
          }
        }).finally(() => {
          this.getClientLoading = false;
        })
      }
    },
    getCurrentPlan() {
      this.$service.get('/plan/' + this.client.plan).then(response => {
        if (response) {
          this.currentPlanName = response.data.name;
          this.currentPlanUserPrice = response.data.userPrice;
        }
      }).finally(() => {
        this.getCurrentPlanLoading = false;
      })
    },
  },
  watch: {
    "formModel.client": {
      handler(val) {
        if (this.showForm && val) {
          this.getClientLoading = true;
          this.getCurrentPlanLoading = true;
          this.getClient();
        } else {
          this.client = null
        }
      }
    },
    "client": {
      handler(val) {
        this.currentPlanName = null;
        this.currentPlanUserPrice = 0;
        this.supervisor = null;
        this.manager = null;
        if (val) {
          if (this.client.plan) {
            this.getCurrentPlan();
          } else {
            this.getCurrentPlanLoading = false;
          }
        } else {
          this.getClientLoading = false;
          this.getCurrentPlanLoading = false;
        }
      }
    }
  },
  i18n: {
    messages: {
      vi: {
        buyUser: 'Mua thêm người dùng',
        currentPlan: 'Gói dịch vụ đang sử dụng',
        userPrice: 'Giá/ người dùng',
        currentUserLimit: 'Số người dùng tối đa hiện tại',
        numberOfUser: 'Số user',
        monthCount: 'Số tháng',
        expireTime: 'Ngày hết hạn',
        note: 'Ghi chú',
        total: 'Thành tiền',
        cancel: 'Huỷ',
        savePlanOrder: 'Lưu đơn hàng',
        discount: 'Số tiền giảm giá',
        numberOfUserToBuy: 'Số người dùng muốn mua thêm',
        numberOfUserGifted: 'Số người dùng tặng thêm',
        creditBalance: 'Số dư trong tài khoản',
        creditLimit: 'Hạn mức',
        sales: 'Nhân viên sales',
        noSales: 'Không có nhân viên sales',
        account: 'Nhân viên account',
        noAccount: 'Không có nhân viên account',
        supervisor: 'Trưởng nhóm',
        noSupervisorFound: 'Không tìm thấy trưởng nhóm',
        manager: 'Trưởng phòng',
        noManagerFound: 'Không tìm thấy trưởng phòng',
        noCurrentPlanFound: 'Không tìm thấy thông tin gói hiện tại'
      },
      en: {
        buyUser: 'Buy user',
        currentPlan: 'Current plan',
        numberOfUser: 'Number of user',
        userPrice: 'Price/ user',
        currentUserLimit: 'Current user limit ',
        monthCount: 'Number of month',
        expireTime: 'Expire time',
        note: 'Note',
        total: 'Total',
        cancel: 'Cancel',
        savePlanOrder: 'Save plan order',
        discount: 'Discount amount',
        numberOfUserToBuy: 'Number of user to buy',
        numberOfUserGifted: 'Number of user gifted',
        creditBalance: 'Credit balance',
        creditLimit: 'Credit limit',
        sales: 'Sales person',
        noSales: 'No sales person',
        account: 'Account',
        noAccount: 'No sales account',
        supervisor: 'Supervisor',
        noSupervisorFound: 'No supervisor found',
        manager: 'Manager',
        noManagerFound: 'No manager found',
        noCurrentPlanFound: 'No current plan found'
      }
    }
  }
}
</script>